import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnalysisApiClientAccess, AppService } from '@nk/access-block';
import { CachingService } from '@nk/caching-lib';
import {
  AppCustomerNetworkRiskScoreSettings,
  AppFeatureKey,
  AppRoleKey,
  COUNTRY_FEATURES,
  NetworkRiskScore,
} from '@nk/data-entities-lib';
import { Observable, switchMap } from 'rxjs';

@Injectable()
export class NetworkRiskScoreService {
  constructor(
    private _analysisApiAccess: AnalysisApiClientAccess,
    private _cachingService: CachingService,
    private _appService: AppService,
  ) {}

  public appCustomerNetworkRiskScoreSettingCache = this._cachingService.create(
    this,
    this.fetchAppCustomerNetworkRiskScoreSetting,
  );
  public fetchAppCustomerNetworkRiskScoreSetting(): Observable<AppCustomerNetworkRiskScoreSettings[]> {
    return this._appService.fetchAppCustomerUuid().pipe(
      switchMap((appCustomerUuid) => {
        return this._analysisApiAccess.get<AppCustomerNetworkRiskScoreSettings[]>(
          `/app_customer/${appCustomerUuid}/app-customer-network-risk-score-setting`,
          undefined,
          [AppFeatureKey.base, AppFeatureKey.network_risk_score, ...COUNTRY_FEATURES],
          [AppRoleKey.network_risk_score],
        );
      }),
    );
  }

  public companyNetworkRiskScoreCache = this._cachingService.create(this, this.fetchCompanyNetworkRiskScore);
  public fetchCompanyNetworkRiskScore(companyIdentifier: string): Observable<NetworkRiskScore[]> {
    let httpParams = new HttpParams();
    if (companyIdentifier) {
      httpParams = httpParams.append('company_identifier', companyIdentifier);
    }
    return this._appService.fetchAppCustomerUuid().pipe(
      switchMap((appCustomerUuid) => {
        return this._analysisApiAccess.get<NetworkRiskScore[]>(
          `/app-customer/${appCustomerUuid}/network-risk-score`,
          { params: httpParams },
          [AppFeatureKey.base, AppFeatureKey.network_risk_score, ...COUNTRY_FEATURES],
          [AppRoleKey.network_risk_score],
        );
      }),
    );
  }
}
